module.exports = __webpack_public_path__ + "static/1-ecee945c875c5035afe953ad510652da.png";